import i18n from "@/i18n";

export const contentFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "layer",
        label: i18n.t("background.layer"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "x",
        label: i18n.t("background.posX"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "y",
        label: i18n.t("background.posY"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }];
